import { Login } from "../../../features";
import { usePostLoginMutation } from "../../../services/auth";
 
const LoginPage = () => {
  return <Login />;
};
export default LoginPage;
